import React from 'react';
import TextFieldMaterial from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import withStyles from '@material-ui/core/styles/withStyles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import PropTypes from 'prop-types';


function InputAdornments(props) {
  const { classes } = props;

  const [values, setValues] = React.useState({
    showPassword: false,
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  return (<TextFieldMaterial
    id="outlined-adornment-password"
    classes={{ root: classes.textField }}
    type={values.showPassword ? 'text' : 'password'}
    placeholder="Passwort"
    value={props.value}
    onChange={props.onChange}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            edge="end"
            aria-label="Toggle password visibility"
            onClick={handleClickShowPassword}
          >
            {values.showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
        ),
    }}
  />);
}


InputAdornments.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.object,
};

InputAdornments.defaultProps = {
  value: '',
  onChange: () => {},
  classes: null,
};

const styles = () => ({
  textField: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 10,
    marginBottom: 10,
  },
});

export default withStyles(styles)(InputAdornments);



// WEBPACK FOOTER //
// ./src/app/components/password-field/password-field.js